import React, { useState, useRef, useEffect } from 'react';
import { useFilterContext } from '../context/FilterContext';
import styles from '../styles/TeamSearch.module.css';

const TeamSearch = () => {
  const { filters, updateFilter } = useFilterContext();
  const [isFocused, setIsFocused] = useState(false);
  const [searchValue, setSearchValue] = useState(filters.teamSearch || '');
  const inputRef = useRef(null);

  // Update search value when filters change
  useEffect(() => {
    setSearchValue(filters.teamSearch || '');
  }, [filters.teamSearch]);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    updateFilter('teamSearch', value);
  };

  // Handle search icon click
  const handleSearchClick = () => {
    inputRef.current?.focus();
  };

  // Handle input focus
  const handleInputFocus = () => {
    setIsFocused(true);
  };

  // Handle input blur
  const handleInputBlur = () => {
    setIsFocused(false);
  };

  // Handle clear search
  const handleClearSearch = () => {
    setSearchValue('');
    updateFilter('teamSearch', '');
    inputRef.current?.focus();
  };

  // Handle escape key
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClearSearch();
      inputRef.current?.blur();
    }
  };

  return (
    <div className={`${styles.teamSearch} ${isFocused ? styles.focused : ''}`}>
      <div className={styles.searchContainer}>
        <button
          type="button"
          className={styles.searchIcon}
          onClick={handleSearchClick}
          aria-label="Focus search input"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </button>
        <input
          ref={inputRef}
          type="text"
          value={searchValue}
          onChange={handleSearchChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onKeyDown={handleKeyDown}
          placeholder="Search teams..."
          className={styles.searchInput}
        />
        {searchValue && (
          <button
            className={styles.clearButton}
            onClick={handleClearSearch}
            title="Clear search"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default TeamSearch;
